"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadioCardClasses = void 0;
var classnames_1 = require("classnames");
var baseCardClasses = "\n        squid-flex \n        squid-flex-col \n        squid-justify-center\n        squid-p-component-radio-card-padding-base\n        squid-border\n        squid-rounded-component-radio-card-border-radius\n        squid-gap-component-radio-card-space-base\n        squid-relative squid-cursor-pointer  \n        squid-border \n        squid-shadow-sm";
var hoverClasses = "\n        hover:squid-bg-alias-state-base-hover \n        hover:squid-border-alias-color-border-hover";
var activeClasses = "\n  focus:squid-ring-2 \n  focus:squid-ring-alias-color-border-active \n  focus:squid-ring-offset-2 \n  focus-visible:squid-ring-2 \n  focus-visible:squid-ring-alias-color-border-active \n  focus-visible:squid-ring-offset-2 \n  ";
var getRadioCardClasses = function (_a) {
    var checked = _a.checked, active = _a.active, disabled = _a.disabled;
    var classes = (0, classnames_1.default)({
        'squid-border-component-radio-card-border-width-default': !checked,
        'squid-border-alias-color-border-base': !disabled,
        'squid-bg-alias-state-base-active': checked,
        'squid-border-alias-color-border-active': checked,
        'squid-border-component-radio-card-border-width-active': checked,
        'active:squid-border-alias-color-border-pressed': !disabled,
        'active:squid-bg-alias-state-base-pressed': !disabled,
    });
    return (0, classnames_1.default)(baseCardClasses, classes, active ? activeClasses : '', !disabled && !active && !checked ? hoverClasses : '');
};
exports.getRadioCardClasses = getRadioCardClasses;
